const hasGivenTheme = (theme, display) => display === theme;

module.exports = { hasGivenTheme };
